module.exports = __webpack_public_path__ + "media/10up.c4617260.mp3";